import Custom from './custom'

export default {
    stateReload:false,
    language: 'en',
    authUser: {},
    accountDetail: {},
    list: [],
    issueList: [],
    banks: [],
    hubs: [],
    zones: [],
    weightCharges: [],
    stores: [],
    notices: [],
    reasons: [],
    merchants: [],
    riders: [],
    logisticPartners: [],
    statusList: Custom.statusList,
    dateParameterList: Custom.dateParameterList,
    dateTypeList: Custom.dateTypeList,
    paymentByList: Custom.paymentByList,
    categoryList: Custom.categoryList,
    monthList: Custom.monthList,
    commonObj: {
        divisionList: [],
        districtList: [],
        thanaList: [],
        merchantList: [],
        areaList: [],
        zoneList: [],
        bankList: [],
        hubList: [],
        logisticPartnerList: [],
        riderList: [],
        reasonList: [],
        weightChargeList: [],
        issueList: [],
    }
}